import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { stats, reviews } from '@/mocks/articles';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt')?.toString()?.trim() || '';
    if (honeypot) {
      setFormStatus('success');
      form.reset();
      return;
    }

    setFormStatus('loading');
    setFormError('');

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'phone_alt' && typeof value === 'string') {
          body.append(key, value);
        }
      });

      const response = await fetch('http://91fuliji.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后再试';
        setFormError(serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  const faqItems = [
    {
      q: '每日吃瓜的内容来源是什么？',
      a: '我们的内容来自50+独家信源渠道以及全网公开资讯的整理汇总，所有内容均经过多重核实后发布，确保信息的真实性和时效性。'
    },
    {
      q: '如何向每日吃瓜投稿爆料？',
      a: '你可以通过本页下方的联系表单提交爆料线索，我们将严格保护爆料人的隐私信息。爆料一经采用，我们会及时与你联系。'
    },
    {
      q: '每日吃瓜更新频率如何？',
      a: '我们保持7x24小时不间断更新，平均每天发布数十条最新爆料内容。关注我们的社交媒体账号可以第一时间获取推送通知。'
    },
    {
      q: '如果发现内容侵权怎么办？',
      a: '如你认为本站内容侵犯了你的合法权益，请通过联系表单提交相关证明材料，我们将在核实后24小时内处理。'
    },
    {
      q: '每日吃瓜有App吗？',
      a: '目前我们主要提供网页版服务，App正在开发中，敬请期待！你可以将本站添加到手机桌面，获得接近App的使用体验。'
    }
  ];

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '每日吃瓜',
    url: 'http://91fuliji.cn/',
    description: '每日吃瓜聚合全网热点娱乐资讯，实时更新网红博主、明星八卦等内幕爆料。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@91fuliji.cn',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <>
      <Navbar />
      <main className="pt-20">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
        <div className="w-full px-4 md:px-6 py-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <section className="max-w-4xl mx-auto mb-16">
            <div className="text-center mb-10">
              <span className="inline-block text-xs font-medium text-foreground-500 border border-foreground-300 rounded-full px-3 py-1 mb-4">
                品牌介绍
              </span>
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                关于<span className="text-primary-500">每日吃瓜</span>
              </h1>
              <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                每日吃瓜是领先的中文娱乐资讯聚合平台，致力于为吃瓜群众提供最新、最快、最全的网红爆料和明星八卦内容。我们聚合全网热点，让每一个爱八卦的你都能第一时间吃到最新鲜的瓜。
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors">
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-500">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="p-6 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">我们的使命</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  让每一位吃瓜群众都能第一时间掌握最新娱乐动态。我们相信，在信息爆炸的时代，快速、准确、有趣的资讯聚合比什么都重要。
                </p>
              </div>
              <div className="p-6 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">核心优势</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  50+独家信源、7x24小时更新、多重事实核实机制，确保每一条爆料都经得起推敲。我们的编辑团队拥有多年娱乐媒体从业经验。
                </p>
              </div>
            </div>
          </section>

          <section className="max-w-4xl mx-auto mb-16">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">用户口碑</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {reviews.map((review) => (
                <div key={review.id} className="p-5 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors">
                  <div className="flex items-center gap-3 mb-3">
                    <div
                      className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
                      style={{ backgroundColor: review.avatarColor }}
                    >
                      {review.name.charAt(0)}
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-900">{review.name}</div>
                      <div className="text-xs text-foreground-500">@{review.name.replace(/\s/g, '')}</div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">
                    &ldquo;{review.content}&rdquo;
                  </p>
                </div>
              ))}
            </div>
          </section>

          <section className="max-w-4xl mx-auto mb-16">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">常见问题</h2>
            <div className="space-y-3">
              {faqItems.map((item, index) => (
                <details key={index} className="group bg-background-100 rounded-lg">
                  <summary className="px-6 py-4 text-sm font-medium text-foreground-900 cursor-pointer flex items-center justify-between">
                    {item.q}
                    <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform text-foreground-400"></i>
                  </summary>
                  <div className="px-6 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </div>
                </details>
              ))}
            </div>
          </section>

          <section className="max-w-2xl mx-auto mb-16">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">联系我们</h2>
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <form onSubmit={handleSubmit} id="contact-form-about">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                  <div>
                    <label htmlFor="name" className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入你的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入你的邮箱"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label htmlFor="subject" className="block text-sm text-foreground-700 mb-1.5">主题</label>
                  <select
                    id="subject"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors cursor-pointer"
                  >
                    <option value="">请选择主题</option>
                    <option value="爆料投稿">爆料投稿</option>
                    <option value="商务合作">商务合作</option>
                    <option value="内容侵权">内容侵权</option>
                    <option value="意见建议">意见建议</option>
                    <option value="其他">其他</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label htmlFor="message" className="block text-sm text-foreground-700 mb-1.5">留言内容</label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    rows={5}
                    maxLength={500}
                    className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                    placeholder="请输入你的留言内容（最多500字）"
                  ></textarea>
                  <div className="text-xs text-foreground-400 mt-1">最多500字</div>
                </div>

                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  readOnly
                  aria-hidden="true"
                  className="antispam-field"
                />

                <button
                  type="submit"
                  disabled={formStatus === 'loading'}
                  className="w-full py-3 bg-primary-500 text-white rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer disabled:opacity-50 whitespace-nowrap"
                >
                  {formStatus === 'loading' ? '提交中...' : '提交留言'}
                </button>

                {formStatus === 'success' && (
                  <p className="mt-4 text-sm text-center text-green-600">提交成功！我们会尽快与你联系。</p>
                )}
                {formStatus === 'error' && formError && (
                  <p className="mt-4 text-sm text-center text-red-500">{formError}</p>
                )}
              </form>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}